import styled from 'styled-components'

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 120px;
  grid-auto-flow: dense;
  border-radius: 16px;

  a {
    text-decoration: none;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    grid-template-rows: unset;
    aspect-ratio: unset;
    gap: 40px;
  }
`

export const Image = styled.div<{ image: string; reverse: boolean }>`
  background-image: url('${({ image }) => image}');
  background-position: center;
  max-width: 100%;
  width: 100%;
  background-size: cover;
  height: 400px;
  border-radius: 16px;
  box-sizing: border-box;
  overflow: hidden;
  align-self: center;

  ${({ reverse }) =>
    reverse &&
    `
      grid-column-end: -1;
  `}

  @media (max-width: 1200px) {
    display: flex;
    flex-direction: column;
    height: 256px;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1200px) {
    justify-content: flex-start;
  }
`

export const Text = styled.div<{ truncate: boolean; showMore: boolean }>`
  font-size: 16px;
  font-weight: var(--font-regular);
  line-height: 1.8;

  strong {
    font-weight: var(--font-bold);
  }
  em {
    font-style: italic;
  }

  a {
    text-decoration: underline;
  }

  ${({ truncate, showMore }) =>
    truncate &&
    (!showMore
      ? `
    display: -webkit-box;
    width: 100%;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 128px;
    overflow: hidden;
    `
      : `
    @media (min-width: 1201px) {
      max-height: unset;
      overflow: unset;
    }
    `)}

  @media (max-width: 768px) {
    line-height: 29px;
    font-size: 16px;
  }
`

export const ReadMore = styled.div`
  font-size: 18px;
  line-height: 1.1;
  font-weight: var(--font-bold);
  margin-top: 15px;
  width: 110px;
  cursor: pointer;

  div {
    display: inline-block;
  }

  &:hover {
    opacity: 0.7;
  }
`
